// extracted by mini-css-extract-plugin
module.exports = {"root":"CartItem_root__n8ra_","quantity":"CartItem_quantity__qmi6Q","productImage":"CartItem_productImage__VapbI","productName":"CartItem_productName__RYrlX"};